<template>
  <div>
    <div class="container">

      <el-table
        :data="tableData"
        stripe
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column prop="Id" label="注册码" align="center"></el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{changeTimeDate(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column prop="RegisterByUser" label="使用人"></el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {getRegisterCode} from '../../../../../request/api'
import Utils from '../../../../../js/Utils'

export default {
  name: 'BackRegisterCodeManage',
  data () {
    return {
      uploadImageId: '',
      query: {
        address: '',
        name: '',
        pageIndex: 1,
        pageSize: 10
      },
      uploadImageVisible: false,
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      pageTotal: 0,
      form: {},
      idx: -1,
      id: -1
    }
  },

  created () {
    this.getData()
  },
  methods: {

    getData () {
      getRegisterCode().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.tableData = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    },
    changeTimeDate (date) {
      var timeStr = Utils.formatDate(date.CreateDate)
      return timeStr
    },
    // 触发搜索按钮
    handleSearch () {
      this.$set(this.query, 'pageIndex', 1)
      this.getData()
    },
    // 删除操作
    handleDelete (index, row) {
      console.log(index)
      console.log(row.id)

      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          // var url = row.id
          // Deljiaocai(url, {}).then(res => {
          //   console.log(res)
          //
          //   if (res.code === '90') {
          //     this.$message({
          //       type: 'success',
          //       message: res.opmsg
          //     })
          //     this.tableData.splice(index, 1)
          //   } else {
          //     this.$message.error(res.opmsg)
          //   }
          // }).catch((error) => {
          //   // error
          //
          //   console.log(error)
          // })
        })
        .catch(() => {})
    }

  }
}
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/user/BackRegisterCodeManage.vue